import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/report.py rate_lookup() / my_rates().

export interface RateRow {
  npa_nxx: string;
  state: string;
  interstate_rate: number;
  intrastate_rate: number;
}

export interface RateLookupResult {
  query: string;
  rows: RateRow[];
  // true when the exact NPA-NXX wasn't on the sheet and the '*' default rate applies.
  fallback: boolean;
}

export interface MyRateRow {
  npa_nxx: string;
  state: string;
  calls: number;
  spend: number;
  interstate_rate: number | null;
  intrastate_rate: number | null;
}

export interface MyRates {
  days: number;
  destinations: MyRateRow[];
  totals: { distinct_npa_nxx: number; calls: number; spend: number };
}

// The lookup box is intentionally NOT wrapped in APIResponse on the server — it
// returns the shape directly (matches the other /reports read endpoints).
export async function rateLookup(q: string): Promise<RateLookupResult> {
  const resp = await api.get<RateLookupResult>("/reports/rate-lookup", { params: { q } });
  return resp.data;
}

export async function getMyRates(limit = 50, days = 30): Promise<MyRates> {
  const resp = await api.get<MyRates>("/reports/my-rates", { params: { limit, days } });
  return resp.data;
}

// The nav gate reads billing_mode from the permissions endpoint; re-exported here
// for the Rates page's own guard so it doesn't import from the users module.
export interface RateVisibility {
  is_admin: boolean;
  billing_mode: string;
}
export async function getRateVisibility(): Promise<RateVisibility> {
  const resp = await api.get<APIResponse<RateVisibility>>("/users/me/permissions");
  return unwrap(resp.data);
}
